<div #swiperContainer class="swiper" [ngClass]="swiperClass()">
    <div class="swiper-wrapper">
        <ng-content />
    </div>
    @if (showPagination()) {
        @if (swiperOptions().pagination) {
            <div class="swiper-pagination"></div>
        }
        @if (swiperOptions().navigation) {
            <ds-arrow size="large" direction="left" variant="strong" [inverse]="true" class="swiper-button-prev" />
            <ds-arrow size="large" direction="right" variant="strong" [inverse]="true" class="swiper-button-next" />
        }
    }
</div>
